import { HEALTH_STATUS, CLEAR_HEALTH_STATUS } from '../constants/ActionTypes';

export default function healthStatus(
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) {
  switch (action.type) {
    case HEALTH_STATUS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data,
      };
    case CLEAR_HEALTH_STATUS:
      return {
        data: {},
        isFetching: false,
        errorMessage: null,
      };
    default:
      return state;
  }
}
